import React from 'react';
import { Callout, Step, DocHeading, DocTable, Shot } from './components';

const LINK = 'text-brand-300 hover:text-brand-200 underline underline-offset-2';

function PageKeyFarm({ navigate }) {
  return (
    <div>
      <h1 className="text-[2.5rem] leading-[1.1] font-semibold text-white tracking-[-0.02em] mb-3">Key Farm</h1>
      <p className="text-gray-400 leading-relaxed mb-8">
        Key Farm farms the <strong className="text-white">Key of Prowess</strong> on{' '}
        <strong className="text-white">Deeps of Demise - First Floor</strong> with 2 to 4
        characters on this PC. One character, <strong className="text-white">A</strong>, holds the
        Fortune Hunter quest for <strong className="text-white">Cyris Wallach</strong>, which must not
        be lost, so it must never be inside the instance when the monster dies.
        The others are the <strong className="text-white">killers</strong>: they run a built-in path,
        kill the monster at its end and loot. The team jumps back and forth between two difficulties,
        and A always waits in the other one. Everything is on the{' '}
        <strong className="text-white">AUTOPILOT &rsaquo; Key farm</strong> tab.
      </p>

      <Callout type="warning">
        <strong>Key Farm needs Party.</strong> Turn on <strong>Play as a party</strong> on{' '}
        <button onClick={() => navigate('party')} className={LINK}>AUTOPILOT &rsaquo; Party</button>{' '}
        in <em>every</em> client first. Without it START stays greyed out, and turning it off while
        the farm runs stops the farm.
      </Callout>

      <DocHeading>What You Need</DocHeading>
      <DocTable
        headers={['Requirement', 'Why']}
        rows={[
          [<strong className="text-white">On A: the Cyris Wallach Fortune Hunter quest accepted</strong>, <>In the game&rsquo;s Journal, on the Fortune Hunters page. <strong className="text-white">Without it Key Farm does not work.</strong> If he is not offered,{' '}<button onClick={() => navigate('quests')} className={LINK}>QUESTS &rsaquo; Fortune Hunters</button>{' '}can refresh the list until he shows up (every refresh costs andermant).</>],
          [<strong className="text-white">2 to 4 game clients on this PC</strong>, 'Each with MortisEngine running. The clients see each other only on the same computer.'],
          [<strong className="text-white">All characters in one in-game group</strong>, 'So that a jump to a difficulty lands everyone in the same instance.'],
          [<strong className="text-white">Play as a party on in every client</strong>, 'Key Farm uses the party connection to know where the others are and what they are doing.'],
          [<strong className="text-white">Exactly one A</strong>, 'The character with the quest. Every other client (1 to 3) is a Killer. Two clients set to A stop the farm.'],
          [<strong className="text-white">The same two difficulties everywhere</strong>, 'Difficulty 1 must be the same on every client, and so must Difficulty 2. Swapped order counts as different.'],
          [<strong className="text-white">Killers: combat and loot set up</strong>, <>On{' '}<button onClick={() => navigate('auto-combat')} className={LINK}>Auto Combat</button>{' '}the WHEN TO FIGHT card switched on, with <strong className="text-white">Also the route&rsquo;s kill targets</strong> ticked, and{' '}<button onClick={() => navigate('auto-loot')} className={LINK}>Auto Loot</button>{' '}on so the key gets picked up.</>],
          [<strong className="text-white">Start outside Deeps of Demise</strong>, 'For example in town. The game cannot travel to the difficulty you are already standing in.'],
        ]}
      />

      <DocHeading>The Tab</DocHeading>
      <p className="text-sm text-gray-400 mb-4">
        The whole feature is one card, <strong className="text-white">KEY OF PROWESS FARM</strong>.
      </p>
      <DocTable
        headers={['Control', 'What it does']}
        rows={[
          [<strong className="text-white">Map</strong>, 'Always Deeps of Demise - First Floor. It cannot be changed.'],
          [<strong className="text-white">Role</strong>, 'A - has the quest, waits · Killer - runs the route.'],
          [<strong className="text-white">Difficulty 1 / Difficulty 2</strong>, 'The two difficulties the team switches between, named as the game names them. The one picked in the other box is left out of the list, because the two must be different.'],
          [<strong className="text-white">START</strong>, 'Starts this client and every other client that has the same two difficulties set. If START is greyed out, the reason is written above it in orange.'],
          [<strong className="text-white">STOP</strong>, 'Stops this client, and with it the whole team.'],
        ]}
      />
      <p className="text-sm text-gray-400 mb-4">
        Role and the two difficulties are greyed out while the farm runs. If a difficulty box says{' '}
        <em>the difficulty list is not readable yet</em>, wait a moment after the character has loaded
        in. While the farm runs, the AUTOPILOT tab shows a green dot. Hover the small round marker
        next to START / STOP for a short summary of the whole feature.
      </p>

      <Shot
        name="key-farm-01-tab.png"
        tab="AUTOPILOT › Key farm"
        caption="A killer during round 5: it kills on Bloodshed while A waits on Merciless; one row per teammate underneath."
        shoot="menushot (stage keyfarm + pairchan team): a Key farm lap egy futó Killer kliensen — Role, Difficulty 1 Merciless, Difficulty 2 Bloodshed, Status running the route, Round 5, Rounds 4 / 0 empty, a társ-sorok („A  Client 1” waiting in the other difficulty), STOP gomb."
      />

      <DocHeading>Setting It Up</DocHeading>
      <Step n={1} title="Start the clients and form a group">
        Log in 2 to 4 characters on this PC and put them in one in-game group. Leave them outside
        Deeps of Demise, for example in town. On <strong>A</strong>, make sure{' '}
        <strong>Cyris Wallach</strong> is accepted on the Fortune Hunters page of the game&rsquo;s
        Journal.
      </Step>
      <Step n={2} title="Turn on party mode everywhere">
        On <strong>AUTOPILOT &rsaquo; Party</strong> switch on <strong>Play as a party</strong> in
        every client.
      </Step>
      <Step n={3} title="Pick the roles">
        On the Key farm tab set <strong>Role</strong> to <em>A - has the quest, waits</em> on the
        character with the quest, and to <em>Killer - runs the route</em> on all the others.
      </Step>
      <Step n={4} title="Pick the same two difficulties on every client">
        Choose <strong>Difficulty 1</strong> and <strong>Difficulty 2</strong>. Once both are chosen,
        the client shows up in the Team rows of the other clients.
      </Step>
      <Step n={5} title="Check the Team rows">
        Every other client should be listed, for example <em>Killer&nbsp;&nbsp;client 2</em>. If Team
        says <em>nobody yet</em>, see Quick Troubleshooting below.
      </Step>
      <Step n={6} title="Press START on any one client">
        The others with the same two difficulties start with it. Each client travels to Difficulty 1
        and the first round begins.
      </Step>

      <Callout type="info">
        <strong>Let the clients see each other before you press START.</strong> A client joins the
        start only if it was already listing the others when START was pressed. If one stays behind,
        press STOP, wait until every Team row is there, and press START again.
      </Callout>

      <DocHeading>How a Round Works</DocHeading>
      <Step n={1} title="Everyone gathers on the kill difficulty">
        On the first round this is Difficulty 1. A waits until every killer has loaded into
        A&rsquo;s instance and has stayed there for a moment.
      </Step>
      <Step n={2} title="A jumps to the other difficulty">
        A travels to the wait difficulty. The killers do not start yet.
      </Step>
      <Step n={3} title="The killers run the built-in path">
        Each killer starts only when it is sure that A has really left its instance &mdash; not just
        asked to jump. Then it walks the path, kills the monster at the end and loots.
      </Step>
      <Step n={4} title="The killers follow A">
        When the path ends, every killer jumps to where A waits. When they have all arrived, the next
        round starts right there: now this is the kill difficulty, and A jumps back to the first one.
      </Step>
      <p className="text-sm text-gray-400 mb-4">
        So the two difficulties take turns every round. The <strong className="text-white">Round</strong>{' '}
        line on the tab always says which is which: <em>kills on &hellip;, waits on &hellip;</em>.
      </p>

      <Callout type="success">
        <strong>The quest is guarded on purpose.</strong> A killer never starts while it cannot tell
        where A is &mdash; not knowing means waiting. If A still shows up in a killer&rsquo;s instance
        while the path runs, that killer stops at once, and so does the rest of the team.
      </Callout>

      <DocHeading>The Built-in Path</DocHeading>
      <p className="text-sm text-gray-400 mb-4">
        The killers do not use a route of yours. The path is built into MortisEngine and is the same
        for everyone: it starts where you arrive on the map and ends next to the monster.
      </p>
      <DocTable
        headers={['Good to know', 'Details']}
        rows={[
          ['It cannot be changed', 'You cannot record, edit or save it. While it is loaded, AUTOPILOT › Editor says: This is the built-in key farm route - it cannot be edited or saved.'],
          ['It replaces your loaded route on the killers', 'Each round loads it over whatever was open on AUTOPILOT › Play. After key farming, load your own route again.'],
          ['It runs once per round', 'Loop at the end does not apply. Key Farm starts it again on the next round.'],
          ['Empty rounds are skipped', 'If the path ends and the monster was never seen, the round counts as empty and the farm goes on. Three empty rounds in a row stop it.'],
        ]}
      />

      <DocHeading>Reading the Card</DocHeading>
      <DocTable
        headers={['Line', 'What it means']}
        rows={[
          [<>Status: <span className="text-gray-500">idle</span></>, 'Nothing is running on this client.'],
          [<>Status: <span className="text-emerald-400">green text</span></>, 'What this client is doing right now — see the next table.'],
          [<>Status: <span className="text-amber-300">stopped: &hellip;</span></>, 'The farm stopped, and the reason follows. See Why It Stopped.'],
          [<strong className="text-white">Round</strong>, 'The round number, then which difficulty the killers kill on and which one A waits on.'],
          [<strong className="text-white">Rounds</strong>, 'How many rounds had the monster, and how many empty ones came in a row (stops at 3). On A it shows the killers’ count.'],
          [<strong className="text-white">Teammate rows</strong>, 'One row per client that takes part (it has chosen both difficulties): A or Killer, its name, and what it is doing, e.g. running the route, or not running, followed by its latest message. Until there is one, a Team line says why (see below).'],
          [<span className="text-amber-300">no signal for Ns</span>, 'On a Team row: that client has not been heard from for more than 3 seconds. Normal for a moment while loading. After 10 seconds of silence the row drops off.'],
          [<span className="text-amber-300">did not start: &hellip;</span>, 'START was pressed, but this client could not start. The reason follows.'],
        ]}
      />

      <p className="text-sm text-gray-400 mb-2 mt-8"><strong className="text-white">What the green status says</strong></p>
      <DocTable
        headers={['Status', 'Who', 'What it means']}
        rows={[
          ['travelling to …', 'Everyone', 'A jump to a difficulty is on its way.'],
          ['waiting for the killers (B)', 'A', 'No killer has joined the round yet.'],
          ['waiting for the killers to load in here (N of M)', 'A', 'Counting the killers that are already in A’s instance.'],
          ['waiting for the other client (A)', 'Killer', 'No A is visible at all.'],
          ['waiting for A to start', 'Killer', 'A is visible but its farm is not running.'],
          ['waiting for A to leave', 'Killer', 'A is still in this instance. The path starts as soon as it is gone.'],
          ['starting the route', 'Killer', 'The built-in path is being started.'],
          ['running the route', 'Killer', 'Walking the path. It adds - the monster was seen once the monster has been spotted.'],
          ['waiting for the killers to kill and come back (N of M here)', 'A', 'A is on the other difficulty, waiting for the killers to finish and arrive.'],
        ]}
      />
      <p className="text-sm text-gray-400 mb-4">
        On Team rows a running client shows its step by name &mdash; <em>entering</em>,{' '}
        <em>in the farm difficulty</em>, <em>travelling</em>, <em>waiting in the other difficulty</em>{' '}
        or <em>running the route</em> &mdash; followed by its green status after a dash. A client that
        is not running, or has stopped, shows <em>not running</em>, followed by its reason if it has one.
      </p>

      <DocHeading>Why START Is Greyed Out</DocHeading>
      <DocTable
        headers={['The orange line says', 'What to do']}
        rows={[
          ['turn on Party mode on this client (Party tab) - every key farm client needs it, with the same party id', 'Switch on Play as a party on AUTOPILOT › Party.'],
          ['choose both difficulties', 'Pick Difficulty 1 and Difficulty 2.'],
          ['the two difficulties must be different', 'Pick two different ones.'],
          ['wait until the character is loaded in', 'The character is on a loading screen. Wait.'],
          ['start from outside Deeps of Demise - the game cannot travel to the difficulty you are already in', 'Leave Deeps of Demise (for example go to town), then press START.'],
          ['Anything about the built-in route', 'This copy of MortisEngine cannot use its key farm path. Update to the latest version; if it stays, contact support.'],
        ]}
      />

      <DocHeading>Why It Stopped</DocHeading>
      <p className="text-sm text-gray-400 mb-4">
        <strong className="text-white">If one client stops, all of them stop.</strong> The others then
        say <em>a team member stopped</em>, so look at the client that stopped first &mdash; its own
        reason is also repeated after the colon.
      </p>
      <DocTable
        headers={['stopped: …', 'What happened']}
        rows={[
          ['you pressed stop', 'STOP was pressed on this client.'],
          ['a team member stopped (A): … / a team member stopped (killer): …', 'Another client stopped. Its reason follows the colon.'],
          ['a team member is gone (no signal)', 'A client was closed, crashed, or lost the party connection for about 15 seconds.'],
          ['a team member’s client restarted', 'A client of the team was restarted during the farm. Start again on all of them.'],
          ['Party mode was turned off - the clients cannot see each other', 'Play as a party was switched off on this client.'],
          ['the clients have different difficulties set', 'Difficulty 1 or Difficulty 2 differs somewhere. Make them identical, in the same order.'],
          ['more than one client is set to A - only one may hold the quest', 'Set only one client to A.'],
          ['a killer is on the same difficulty but in another instance - are all clients in the same group?', 'A killer landed in a different copy of the map. Put every character in one in-game group.'],
          ['no killer arrived in this instance in time · not every killer arrived in this instance in time', 'A waited 3 minutes for the killers to load in next to it.'],
          ['A did not leave in time', 'A killer waited 3 minutes for A to jump away.'],
          ['the killers did not come back in time', 'A waited 18 minutes on the other difficulty (the longest a path may take, plus 3 minutes) and not every killer arrived.'],
          ['the travel did not arrive in 90 s', 'A jump never finished: a very long loading screen, or the game did not let the character in.'],
          ['the travel could not be sent', 'The game was busy every time the jump was tried.'],
          ['the travel ended on another map (…)', 'The jump landed somewhere other than Deeps of Demise.'],
          ['this character left the farm map (now on …)', 'Something moved the character off the map while it was waiting or running the path.'],
          ['A came into this instance while the route ran - stopped to protect the quest', 'The safety stop. A appeared next to a killer during the kill. Check that everyone is in one group and start again.'],
          ['the route did not start · the route could not be started', 'The built-in path did not get going. Look at the status on AUTOPILOT › Play.'],
          ['the route stopped: …', 'The path ended with a problem. The reason is the same one AUTOPILOT › Play shows.'],
          ['the route took too long', 'One run of the path took more than 15 minutes.'],
          ['the route ended with the monster still alive - the path must end next to the monster', 'The killer walked the path but did not kill the monster. Check Auto Combat: WHEN TO FIGHT on, Also the route’s kill targets ticked, skills set up.'],
          ['3 rounds in a row without the monster', 'The monster was not there three rounds in a row. Check that A still has the Cyris Wallach quest accepted, then start again.'],
        ]}
      />

      <DocHeading>Quick Troubleshooting</DocHeading>
      <DocTable
        headers={['What you see', 'What it is']}
        rows={[
          ['Team: Party mode is off on this client', 'Switch on Play as a party on AUTOPILOT › Party.'],
          ['Team: nobody yet - …', 'The other clients do not have Play as a party on, or have not chosen both difficulties on their Key farm tab.'],
          ['Only some clients started', 'The rest had different difficulties, did not see the others yet, or could not start — their own tab says did not start: …. Press STOP, fix it, START again.'],
          ['A killer keeps saying waiting for A to leave', 'A has not jumped yet. Look at the status on A’s tab.'],
          ['A keeps saying waiting for the killers to load in here', 'A killer is still loading or landed elsewhere. Look at that killer’s tab.'],
          ['The killer runs past the monster', 'Also the route’s kill targets is not ticked on AUTOPILOT › Combat.'],
          ['The key is not picked up', 'Auto Loot is off, or its filters skip the key.'],
        ]}
      />
      <Callout type="info">
        Key Farm handles the jumps and the timing. The killing is done by{' '}
        <button onClick={() => navigate('auto-combat')} className={LINK}>Auto Combat</button>, the
        picking up by{' '}
        <button onClick={() => navigate('auto-loot')} className={LINK}>Auto Loot</button>, and the
        clients find each other through{' '}
        <button onClick={() => navigate('party')} className={LINK}>Party</button>.
      </Callout>
    </div>
  );
}

export default PageKeyFarm;
